import { type HttpClient } from '@/application/interfaces/http-client';

import getOptin from './get-optin';
import unsubscribeOptins from './unsubscribe-optins';

const OptinsService = (httpClient: HttpClient.Instance) => ({
  getOptin: getOptin(httpClient),
  unsubscribeOptins: unsubscribeOptins(httpClient),
});

export default OptinsService;
export * from './get-optin';
export * from './unsubscribe-optins';
